const React = require("react");
const createReactClass = require("create-react-class");
const {augmentHOCWrapper} = require("../util/HOCUtil");
const WindowResize = require("../util/WindowResize");

// For new code, prefer the ContainerDims.jsx component in core/view. This is
// kept for backwards compatibility.

const getCurrentDims = function(skipOnServer, props) {
	if (skipOnServer && process.env.IS_NODE) {
		return WindowResize.getEmptyDims();
	} else {
		return WindowResize.getCurrentDims();
	}
};

module.exports = augmentHOCWrapper(function(
	Component,
	{skipOnServer = false} = {}
) {
	return createReactClass({
		displayName: "ContainerDims:" + Component.displayName,

		getInitialState: function() {
			return {containerDims: getCurrentDims(skipOnServer, this.props)};
		},

		statics: {
			getDerivedStateFromProps: function(props) {
				return {containerDims: getCurrentDims(skipOnServer, props)};
			},
		},

		componentDidMount: function() {
			this._dimsHandler = newDims => {
				if (this._unmounted) {
					return;
				}
				if (this.state.containerDims !== newDims) {
					this.setState({containerDims: newDims});
				}
			};
			WindowResize.addDimsListener(this._dimsHandler);
		},

		componentWillUnmount: function() {
			// Unsubscribing is not enough on its own; we might unmount this component
			// while handling a resize event that hasn't called our listener yet.
			this._unmounted = true;
			WindowResize.removeDimsListener(this._dimsHandler);
		},

		render: function() {
			// We can't render the ContainerDims component here since the ref
			// forwarding mechanism in HOCUtil will find it instead, so that's why
			// this component and ContainerDims are copy-pasted.
			return (
				<Component {...this.props} containerDims={this.state.containerDims} />
			);
		},
	});
});
